export default __webpack_public_path__ + "slices/main/assets/public/fonts/inter/inter-bold.c7c0091f1b2b06064572ec0016f1e142.woff";